import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import * as Headings from 'UIComponents/elements/headings';
import { getMessage } from './MESSAGE';
import { KOALA } from 'HubStyleTokens/colors';
import { devices } from '../styles/viewports.styles';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
const StyledBaseMessageCaption = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledBaseMessageCaption",
  componentId: "y4ajis-0"
})(["", ""], props => !props.isFramedCentredStep ? `border-top: 3px solid ${KOALA};
     padding-top: 1.875rem;
     display: flex;
     align-items: center;
     justify-content: center;
     flex-direction: column;


    .PERSON_WITH_BOX,
    .WHITE_HOUSE,
    .HANDS {
      max-width: 100%;
    }

    @media ${devices.tablet} {
      border: none;
      padding-top: 0;
    }` : `
    text-align: center;
    `);
const Caption = styled.div.withConfig({
  displayName: "BaseMessageCaption__Caption",
  componentId: "y4ajis-1"
})(["text-align:", ";margin-bottom:3rem;max-width:90%;line-height:30px;span:not(.checked-list-icon){font-size:23px;font-weight:500;}@media ", "{order:2;margin-top:2rem;margin-bottom:0;}"], ({
  textAlign
}) => textAlign || 'center', devices.tablet);
const StyledChildContainer = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledChildContainer",
  componentId: "y4ajis-2"
})(["", ""], props => props.isFramedCentredStep && `@media ${devices.desktop} {
      height: 140px;
      top ${props.topMargin}px;
      position: relative;
    }`);
export const BaseMessageCaption = ({
  children,
  content,
  headingLevel = 'H4',
  messageKey,
  className,
  textAlign
}) => {
  const {
    captionImage,
    captionImageHeight,
    topMargin
  } = getMessage(messageKey);
  const hasTitle = isValidI18nKey(`message.${messageKey}.title`);
  const hasSubtitle = isValidI18nKey(`message.${messageKey}.subtitle`);
  const Heading = Headings[headingLevel];
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  return /*#__PURE__*/_jsx("div", {
    className: className,
    children: /*#__PURE__*/_jsxs(StyledBaseMessageCaption, {
      isFramedCentredStep: isFramedCentredStep,
      children: [(hasTitle || hasSubtitle || content) && /*#__PURE__*/_jsxs(Caption, {
        className: messageKey,
        textAlign: textAlign,
        children: [hasTitle && /*#__PURE__*/_jsx(Heading, {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `message.${messageKey}.title`
          })
        }), hasSubtitle && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `message.${messageKey}.subtitle`,
          options: {
            captionImage,
            captionImageHeight
          }
        }), content && /*#__PURE__*/_jsx("div", {
          children: content
        })]
      }), /*#__PURE__*/_jsx(StyledChildContainer, {
        isFramedCentredStep: isFramedCentredStep,
        topMargin: topMargin,
        children: children
      })]
    })
  });
};